import { render, staticRenderFns } from "./MyCarousel.vue?vue&type=template&id=09f9eb15&"
import script from "./MyCarousel.vue?vue&type=script&lang=js&"
export * from "./MyCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports